import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=2539e194&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=js"
export * from "./Requests.vue?vue&type=script&lang=js"
import style0 from "./Requests.vue?vue&type=style&index=0&id=2539e194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539e194",
  null
  
)

export default component.exports